import { IObjektVy } from '../../../../../Types/ObjektVy';
import { standardVy } from '../../../../../Utils/ObjektVyUtils';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';

const forstaSida: IObjektVy = ObjektVySida('forstaSida', [
  [objektVyGrupp('Info', ['LEVVILLKORKOD', 'BENAMNING'])],
]);

export const standard: IObjektVy = standardVy([forstaSida]);

export const LeveransvillkorVyer: IObjektVy[] = [standard];
